import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FormHeader } from "@/components/FormHeader";
import { CaptureButtons } from "@/components/CaptureButtons";
import { ClienteSections } from "@/components/ClienteSections";
import { ConsentChecks } from "@/components/ConsentChecks";
import { emptyCliente, captureToReferente, validateCliente } from "@/lib/clienteConstants";
import { API } from "@/lib/api";

export default function ClienteForm() {
  const [form, setForm] = useState(emptyCliente);
  const [saving, setSaving] = useState(false);
  const [pending, setPending] = useState(null);

  const set = (key, val) => {
    if (key === "referenti" && pending && val.length > form.referenti.length) {
      const old = new Set(form.referenti.map((r) => r.reparto));
      val = val.map((r) => (old.has(r.reparto) ? r : { ...r, ...pending }));
      setPending(null);
    }
    setForm((f) => ({ ...f, [key]: val }));
  };

  const handleCapture = (data, photo) => {
    const ref = captureToReferente(data);
    setForm((f) => {
      const next = { ...f, ...(data.ragione_sociale ? { ragione_sociale: data.ragione_sociale } : {}), ...(photo ? { card_photo: photo } : {}) };
      if (Object.keys(ref).length && f.referenti.length) {
        next.referenti = f.referenti.map((r, i) => (i === 0 ? { ...r, ...ref } : r));
      }
      return next;
    });
    if (Object.keys(ref).length && !form.referenti.length) {
      setPending(ref);
      toast.info("Seleziona il reparto del referente: i dati del biglietto verranno inseriti lì");
    }
  };

  const handleSave = async () => {
    const error = validateCliente(form);
    if (error) return toast.error(error);
    setSaving(true);
    try {
      await axios.post(`${API}/clienti`, form);
      toast.success("Scheda anagrafica salvata");
      setForm(emptyCliente());
      setPending(null);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      toast.error("Errore durante il salvataggio");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 font-body" data-testid="cliente-form-page">
      <FormHeader historyPath="/anagrafica/elenco" historyLabel="Elenco Anagrafiche" />
      <main className="max-w-3xl mx-auto px-4 md:px-8 py-6 pb-32 space-y-6">
        <div className="text-center py-2">
          <h1 className="font-heading text-3xl font-bold tracking-tight text-buscema-green">Scheda Anagrafica Cliente</h1>
        </div>
        <CaptureButtons onData={handleCapture} photo={form.card_photo} />
        <ClienteSections form={form} set={set} />
        <ConsentChecks form={form} set={set} />
      </main>
      <div className="fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-gray-200 p-4">
        <div className="max-w-3xl mx-auto">
          <Button
            data-testid="save-cliente-btn"
            onClick={handleSave}
            disabled={saving}
            className="w-full min-h-[60px] rounded-xl bg-buscema-green hover:bg-buscema-greenDark text-white text-lg font-semibold gap-3 shadow-lg"
          >
            {saving ? <Loader2 className="w-6 h-6 animate-spin" /> : <Save className="w-6 h-6" />}
            Salva Scheda
          </Button>
        </div>
      </div>
    </div>
  );
}
